import { useMutation, useQuery } from "@tanstack/react-query";

import { processRequest } from "@api/config";
import { TGoal, goalsAPI } from "@api/goals";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";

export type TGetGoalListQueryResponse = {
	activeGoal: TGoal | null;
	goalQueue: TGoal[];
};

export const getGoalListQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.GET_GOAL_LIST],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_GOAL_LIST,
				request: (token) => goalsAPI.getGoalListAsync({ token }),
			});
			return data;
		},
		select: (data) => {
			if (data.goals.length === 0) {
				return {
					activeGoal: null,
					goalQueue: [],
				};
			}

			/** ERROR OF ARCHITECTURE: ACTIVE GOAL SHOULD HAVE ONLY ONE STATUS */
			const activeGoal = data.goals.find((goal) => goal.status === "in_progress" || goal.status === "away");
			const goalQueue = data.goals.filter((goal) => goal.status !== "in_progress" && goal.status !== "away");

			return {
				activeGoal: activeGoal ?? null,
				goalQueue,
			};
		},
	});

export const updateGoalQueueMutation = () =>
	useMutation({
		mutationFn: async (data: TGoal[]) =>
			processRequest({
				prefix: API_PREFIXES.UPDATE_GOAL_QUEUE,
				request: (token) => goalsAPI.updateGoalQueueAsync({ token, data }),
			}),
	});

export const deleteGoalByIdMutation = () =>
	useMutation({
		mutationFn: async (goalId: string) =>
			processRequest({
				prefix: API_PREFIXES.DELETE_GOAL_BY_ID,
				request: (token) => goalsAPI.deleteGoalByIdAsync({ token, goalId }),
			}),
	});

export const startGoalMutation = () =>
	useMutation({
		mutationFn: async () =>
			processRequest({
				prefix: API_PREFIXES.START_GOAL,
				request: (token) => goalsAPI.startGoalAsync({ token }),
			}),
	});
